import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Grid, Button } from "@mui/material";
import { CustomSelectFiled, CustomFormGroup } from "./../../Components/Common";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import "./AssignCandidateForm.css";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import { useParams } from "react-router-dom";
import {
  assignCandidate,
  getAssignUser,
  getCandidateStatus,
  deleteandassignCandidate,
} from "./ApiCalls";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AssignCandidateForm = () => {
  const [selectedAssignUser, setSelectedAssignUser] = useState("");
  const [usersList, setUsersList] = useState([]);
  const [status, setStatus] = useState([]);

  let candidate_ids = [useParams()];
  console.log(candidate_ids);
  const lastlocation = useParams();
  const page = useParams().page;
  const navigate = useNavigate();

  const notify = (msg) =>
    toast(msg, {
      position: "bottom-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });

  const assignCandidates = () => async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    assignCandidate(
      candidate_ids[0].candidateId.split(","),
      data.get("user"),
      data.get("status")
    )
      .then((response) => {
        console.log("hii");
        notify("Candidates Assigned Successfully");
        setTimeout(() => navigate("/all-candidate"), 3000);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getAssignUser()
      .then((response) => {
        setUsersList(
          response.data.map((users) => ({
            label: users.username,
            value: users.u_id,
          }))
        );
      })
      .catch((err) => {
        console.log(err);
      });
    getCandidateStatus()
      .then((response) => {
        setStatus(
          response.data.map((status) => ({
            label: status.candidate_status,
            value: status.candidate_status,
          }))
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <Breadcrumb
        PageName="Assign Candidate"
        BackButton={[
          true,
          "Back",
          lastlocation.page === "assignUser"
            ? "/userleads"
            : lastlocation.lastlocation === "upcomingleads"
            ? "/upcomingleads"
            : lastlocation.lastlocation === "todaysleads"
            ? "/todaysleads"
            : lastlocation.lastlocation === "nonassignleads"
            ? "/nonassignleads"
            : lastlocation.lastlocation
            ? "/leads-by-status/" + lastlocation.lastlocation + "/"
            : "/total-leads",
          <ArrowBackIosOutlinedIcon />,
        ]}
      />

      <form onSubmit={assignCandidates()}>
        <Box className="custom-card" sx={{ height: "18vw" }}>
          <Typography variant="h4" className="custom-card-head">
            Candidate Selected :{" "}
            {candidate_ids[0].candidateId.split(",").length}
          </Typography>
          <Box p={3}>
            <Grid container spacing={2} mb={2}>
              <CustomFormGroup
                formlabel="Team Candidateer"
                FormField={
                  <CustomSelectFiled
                    options={usersList}
                    name="user"
                    onChange={(event) => setSelectedAssignUser(event.value)}
                  />
                }
              />

              <CustomFormGroup
                formlabel="Candidate Status"
                FormField={
                  <CustomSelectFiled
                    options={status}
                    Selectlabel="HR"
                    name="status"
                    onChange={(event) => setSelectedAssignUser(event.value)}
                  />
                  //   <CustomMultiSelectFiled
                  //     options={status}
                  //     name="status"
                  //     Selectlabel="Tele Caller"
                  //     onChange={(event) => setSelectedAssignUser(event.value)}
                  //     inputrole="assign user"
                  //   />
                }
              />
            </Grid>
          </Box>
          <Box p={3}>
            {/* <Button
              type="submit"
              name="submitButton"
              value="delete_assign"
              variant="contained"
              disableElevation
            >
              Delete & Assign Candidate
            </Button> */}
            <Button
              type="submit"
              variant="contained"
              name="submitButton"
              value="Assign"
              disableElevation
            >
              Assign Candidate
            </Button>
          </Box>
        </Box>
      </form>

      <ToastContainer
        position="bottom-center"
        autoClose={1000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </>
  );
};

export default AssignCandidateForm;
